import {ethers} from 'ethers';
import {createContext, ReactNode, useContext} from 'react';

const Web3ProviderContext = createContext<{
  mainnetProvider: ethers.providers.Provider | null;
  provider: ethers.providers.Provider | null;
  isWallet: boolean;
}>({mainnetProvider: null, provider: null, isWallet: false});

export function Web3Provider({
  mainnetProvider,
  provider,
  isWallet,
  children,
}: {
  mainnetProvider?: ethers.providers.Provider | null;
  provider?: ethers.providers.Provider | null;
  isWallet: boolean;
  children: ReactNode;
}) {
  return (
    <Web3ProviderContext.Provider
      value={{mainnetProvider: mainnetProvider || null, provider: provider || null, isWallet}}>
      {children}
    </Web3ProviderContext.Provider>
  );
}

export function useWeb3Provider() {
  return useContext(Web3ProviderContext);
}
